import {
  GLOBAL_PREFIX,
  LAYOUT_CONTAINER_MEDIUM,
} from '@/router/constants';

const PREFIX = `${GLOBAL_PREFIX}/organisation`;


const routes = [
  {
    path: PREFIX,
    name: "organisation-home",
    component: () => import("@/views/organisation/HomeView.vue"),
    meta: {
      title: 'word.overview',
      app: 'organisation',
      navRouteActive: 'organisation-home',
    },
  },
  {
    // Chosen by getLandingRoute for someone with more than one organisation
    // and no partner. No side nav: no organisation has been picked yet.
    path: `${PREFIX}/choose/`,
    name: "organisation-chooser",
    component: () => import("@/views/organisation/OrganisationChooserView.vue"),
    meta: {
      app: 'organisation',
      hideSideNav: true,
      hideBreadcrumbs: true,
    },
  },
  {
    path: `${PREFIX}/onboarding/`,
    name: "organisation-member-onboarding",
    component: () => import("@/views/organisation/OrganisationMemberOnboardingView.vue"),
    meta: {
      app: 'organisation',
      layout: LAYOUT_CONTAINER_MEDIUM,
      hideBreadcrumbs: true,
    },
  },
  // The screen was renamed from "aanmelden" to "aanvragen"; these keep links
  // and bookmarks to the old paths working.
  {
    path: `${PREFIX}/register-research/`,
    redirect: { name: "request-research" },
  },
  {
    path: `${PREFIX}/register-research/details/`,
    redirect: { name: "request-research-details" },
  },
  {
    path: `${PREFIX}/request-research/`,
    name: "request-research",
    component: () => import("@/views/organisation/RegisterResearchView.vue"),
    meta: {
      title: 'phrase.request_research',
      app: 'organisation',
      overlay: 'lighter',
      navRouteActive: 'request-research',
      allowUnverifiedMembership: true,
    },
  },
  {
    path: `${PREFIX}/create-research/:researchType/`,
    name: "request-research-builder",
    component: () => import("@/views/organisation/RegisterResearchBuilderView.vue"),
    meta: {
      title: 'phrase.request_research',
      requiresOrganisation: true,
      app: 'organisation',
      navRouteActive: 'request-research',
      overlay: 'lighter',
      allowUnverifiedMembership: true,
      // The package sign-up buttons on the pricing page land here; most of
      // those visitors have no account yet, so they sign up first (the sign-up
      // screen links to login for those who do).
      unauthenticatedRedirect: 'common-register-account',
    },
  },
  {
    path: `${PREFIX}/request-research/details/`,
    name: "request-research-details",
    component: () => import("@/views/organisation/RegisterResearchDetailsView.vue"),
    meta: {
      title: 'phrase.request_research',
      requiresOrganisation: true,
      app: 'organisation',
      navRouteActive: 'request-research',
      allowUnverifiedMembership: true,
    },
  },
  {
    path: `${PREFIX}/detail/`,
    name: "organisation-detail",
    component: () => import("@/views/organisation/OrganisationDetailView.vue"),
    meta: {
      title: 'phrase.my_organisation',
      app: 'organisation',
      navRouteActive: 'organisation-detail',
    },
  },
  {
    path: `${PREFIX}/documents/`,
    name: "organisation-document-list",
    component: () => import("@/views/organisation/OrganisationDocumentListView.vue"),
    meta: {
      title: 'word.documents',
      app: 'organisation',
      navRouteActive: 'organisation-document-list',
    },
  },
  {
    path: `${PREFIX}/documents/:uuid`,
    name: "organisation-document-detail",
    component: () => import("@/views/organisation/OrganisationDocumentDetailView.vue"),
    meta: {
      title: 'word.document',
      app: 'organisation',
      navRouteActive: 'organisation-document-list',
    },
  },
  {
    path: `${PREFIX}/chat/`,
    name: "organisation-chat-thread-get-or-create",
    component: () => import("@/views/organisation/ChatThreadGetOrCreateView.vue"),
    meta: {
      title: 'word.ai_assistant',
      app: 'organisation',
      navRouteActive: 'organisation-chat-thread-get-or-create',
      hideBreadcrumbs: true,
    },
  },
   {
    path: `${PREFIX}/chat/:uuid`,
    name: "organisation-chat-thread-detail",
    component: () => import("@/views/organisation/ChatThreadDetailView.vue"),
    meta: {
      title: 'word.ai_assistant',
      app: 'organisation',
      navRouteActive: 'organisation-chat-thread-get-or-create',
    },
  },
  {
    path: `${PREFIX}/research-proposal-intake/:uuid?`,
    name: "organisation-research-proposal-intake-chat",
    component: () => import("@/views/organisation/ResearchProposalIntakeChatView.vue"),
    meta: {
      title: 'phrase.request_research_ai_intake',
      requiresOrganisation: true,
      app: 'organisation',
      navRouteActive: 'request-research',
    },
  },
  {
    path: `${PREFIX}/research-proposals/`,
    name: "organisation-research-proposal-list",
    component: () => import("@/views/organisation/ResearchProposalListView.vue"),
    meta: {
      title: 'word.research_proposals',
      app: 'organisation',
      navRouteActive: 'organisation-research-proposal-list',
    },
  },
  {
    path: `${PREFIX}/research-proposals/:id`,
    name: "organisation-research-proposal-detail",
    component: () => import("@/views/organisation/ResearchProposalDetailView.vue"),
    meta: {
      title: 'word.research_proposal',
      app: 'organisation',
      navRouteActive: 'organisation-research-proposal-list',
    },
  },
  {
    path: `${PREFIX}/researches/:researchUuid/builder/`,
    alias: `${GLOBAL_PREFIX}/researches/:researchUuid/builder`,
    name: "organisation-research-builder-v2",
    component: () => import("@/views/organisation/v2/ResearchBuilderV2.vue"),
    meta: {
      title: 'word.research_setup',
      app: 'organisation',
      navRouteActive: 'organisation-home',
      allowUnverifiedMembership: true,
    },
  },
  {
    path: `${PREFIX}/researches/:researchUuid/dashboard`,
    alias: `${GLOBAL_PREFIX}/researches/:researchUuid/dashboard`,
    name: "organisation-research-dashboard-v2",
    component: () => import("@/views/organisation/v2/ResearchDashboardV2.vue"),
    meta: {
      title: 'word.dashboard',
      app: 'organisation',
      navRouteActive: 'organisation-home',
      hideSideNav: true,
    },
  },
];

export default routes;
